







































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import ButtonComponent from '@components/004-ButtonComponent/ButtonComponent.vue';
import TopCapSVG from './topcap.svg';
import BottomCapSVG from './bottomcap.svg';

@Component({
	hydration: 'vanilla',
	componentId: 'C013',
	components: {
		ButtonComponent,
		TopCapSVG,
		BottomCapSVG
	}
})
export default class Modal extends Vue {
	@Prop(String)
	protected readonly buttonText?: string;

	@Prop({ type: String, default: 'default' })
	protected readonly variant?: 'video' | 'small' | 'medium-blue';

	@Prop({ type: String, default: 'Modal panel' })
	protected readonly headline?: string;

	@Prop({ type: Number, default: 0 })
	protected readonly priority!: number;

	protected get hasTriggerSlot(): boolean {
		return !!this.$slots.trigger;
	}
}
